var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"relative min-h-screen font-body antialiased text-gray-700 flex justify-center"},[_c('router-view',{attrs:{"id":"main-view"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }